<div>
  <div class="modal-header font-size-18 text-bold artstuff-orange-fg">{{ 'DIALOG.HEADER' | translate }}</div>
  <div class="w-100-p h-40 my-24">{{ 'DIALOG.BODY' | translate }}</div>
  <div fxLayout="row" fxLayoutAlign="center center">
    <button mat-raised-button class="artstuff-orange mat-subheading-2 text-bold text-uppercase w-220 h-36" (click)="dialogRef.close(false)">
      {{ 'DIALOG.OK_BTN_TEXT' | translate }}
    </button>
  </div>
</div>
